import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import Cookies from 'js-cookie'
import enLocale from 'vant/lib/locale/lang/en-US'
import thLocale from 'vant/lib/locale/lang/th-TH'
import zhLocale from 'vant/lib/locale/lang/zh-CN'
import en from '@/locales/en/en'
import zh from '@/locales/zh/zh'
import th from '@/locales/th/th'

Vue.use(VueI18n)

// 合并 vant + 自定义语言
const messages = {
  en: {
    ...enLocale,
    ...en
  },
  zh: {
    ...zhLocale,
    ...zh
  },
  th: {
    ...thLocale,
    ...th
  }
}

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'th', // 默认语言
  messages,
  silentTranslationWarn: true
})

// i18n.locale = localStorage.getItem('lang') || 'th'

export default i18n
